import { IUserMedal } from './userMedal';
export interface IEnterpriseProfileItem {
    is_show: 0 | 1;
    show_index: number;
    type: PROFILE_MODULE;
    type_name?: string;
}
export enum PROFILE_RECEIVE_MESSAGE_ACT {
    INIT, // 初始化
    UPDATE_EDITOR, // 更新编辑状态
    UPDATE_INDEX, // 更新排序位置
    UPDATE_SHOW, // 更新是否显示
    UPDATE_INFO, // 更新模块信息
    UPDATE_LIST // 更新数据列表
}
export enum PROFILE_MODULE {
    ACHIEVEMENT = 'achievement', // 我的成就
    ENTERPRISE_CERTIFICATE = 'enterprise_certificate', // 企业证书
    PERSONAL_PROFILE = 'personal_profile', // 个人简介
    MESSAGE = 'message', // 精选留言
    MANAGE_CIRCLE = 'manage_circle', // 管理的学习圈
    JOIN_CIRCLE = 'join_circle', // 加入的学习圈
    MANAGE_COURSE = 'manage_course', // 管理的课程
    PARTICIPATE_COURSE = 'participate_course' // 参与的课程
}

export interface IProfileReceiveMessage<T> {
    source: string;
    act: PROFILE_RECEIVE_MESSAGE_ACT;
    data: T;
}

export interface IProfileInfo {
    umu_id: string;
    teacher_id: string;
    enterprise_id: string;
    /*获取企业证书个数*/
    enterprise_certificate_count?: number;
    /*是否开启企业证书*/
    enterprise_certificate_stat?: 0 | 1;
    /**是否为认证讲师 */
    certification_status: number;
    /**
     * 加密 umu_id
     */
    profile_id: string;
    avatar: string;
    /**
     * 个人用户页面模块配置信息
     */
    enterprise_profile_items: IEnterpriseProfileItem[];
    /**
     * 用户名
     */
    user_name: string;

    /**
     * 关注数
     */
    follow_count: number;

    /**
     * 被关注数
     */
    followed_count: number;

    /**
     * 用户等级
     */
    user_level: number;

    /**
     * 影响的学员数
     */
    affected_student_count: number;

    /**
     * 用户勋章数
     */
    user_medal_count: number;

    /**
     * 完成的小节数
     */
    finish_session_count: number;

    /**
     * 发布的主题数
     */
    topic_count: number;

    /**
     * 回复数
     */
    reply_count: number;

    /**
     * 点赞数
     */
    likes_count: number;
    medal_list: IUserMedal[];
    show_user_level: 0 | 1;

    /**
     * 当前用户有没有关注目标用户
     */
    is_followed: 0 | 1;

    /**
     * 自我介绍
     */
    remark: string;

    /**
     * 完成的小节数
     */
    finish_element_count: number;

    /**
     * 发言数
     */
    comment_count: number;
    is_allow_chat: 0 | 1;
    is_shield: number;
}
